import * as types from './types';

export const setPageSize = (payload) => ({
  type: types.SET_PAGE_SIZE,
  payload,
});
export const getPageSize = () => ({
  type: types.GET_PAGE_SIZE,
});
